import React from 'react'
import styled from 'styled-components'

import { Box, ICONS_NAME, IconV2 } from '@/elements'
import { TableCell } from '../TableCell'
import { TableFilter } from '../TableFilter'

import { Transition } from '@/utils'

const sorterSize = 14

const TableHeaderElement = styled.th`
  padding: 0;
  height: 0; // fake height to make cell height work
  text-align: left;
  min-width: ${({ $minWidth }) => $minWidth};
  width: ${({ width }) => width}!important;

  &[data-cansort] {
    user-select: none;

    .table-sorter {
      opacity: 0.2;
    }

    &:hover {
      .table-sorter {
        opacity: 0.6;
      }

      .table-sorter-header {
        margin: ${({ justify }) =>
    justify === 'center' ? `0 0 0 ${sorterSize}px` : '0'};
      }
    }
  }

  &[data-issorted] {
    .table-sorter {
      opacity: 1 !important;
    }

    .table-sorter-header {
      margin: 0;
    }
  }

  .table-sorter-header {
    transition: margin ${Transition.fast};
  }

  .table-sorter {
    cursor: pointer;
    transition: opacity ${Transition.fast};
  }
`

export const TableHeader = ({
    type,
    colSpan,
    width,
    canSort,
    isSorted,
    onClick,
    getRowProps = () => ({}),
    getColumnProps = () => ({}),
    getHeaderProps = () => ({}),
    children,
    justify,
    isFiltered,
    minWidth,
    column,
}) => {
    const props = { ...getRowProps(), ...getColumnProps(), ...getHeaderProps() }

    return (
        <TableHeaderElement
            type={type}
            className="table-header"
            colSpan={colSpan}
            width={width}
            $minWidth={minWidth}
            justify={justify}
            {...(canSort && children && { 'data-cansort': '' })}
            {...(isSorted && { 'data-issorted': '' })}
            {...props}
            {...props.headerProps}
        >
            <TableCell
                type={type}
                gap="5px"
                whiteSpace="nowrap"
                align="flex-start"
                variant="subtitle2"
                {...props}
                {...props.headerProps}
            >
                <Box width="100%" direction="column" gap="5px">
                    <Box justify={justify} align="center">
                        <Box className="table-sorter-header">{children}</Box>

                        {canSort && children && (
                            <Box className="table-sorter" onClick={onClick}>
                                <IconV2
                                    name={
                                        isSorted === 'asc'
                                            ? ICONS_NAME.expandUp
                                            : ICONS_NAME.expandDown
                                    }
                                    size={sorterSize}
                                />
                            </Box>
                        )}
                    </Box>

                    {isFiltered ? (
                        <Box width="100%">
                            <TableFilter column={column} />
                        </Box>
                    ) : null}
                </Box>
            </TableCell>
        </TableHeaderElement>
    )
}